import { useRouter } from 'next/router';

export function useRouterQuery(key: string[]): Record<string, string>;
export function useRouterQuery(key: string): string;
export function useRouterQuery(key: string | string[]) {
  const router = useRouter();

  if (Array.isArray(key)) {
    return key.reduce(
      (prev, curr) => ({ ...prev, [curr]: router.query[curr] as string }),
      {},
    ) as Record<string, string>;
  }

  return router?.query[key] as string;
}
